import React from 'react';
import logo from '../../../assets/images/logo-spartacus.png';
import './ContentLoader.css';

const ContentLoader = () => (
  <div className="content-loader-overlay">
    <div className="content-loader-center">
      <img src={logo} alt="Spartacus" className="content-loader-logo" />
      <div className="content-loader-spinner" />
    </div>
  </div>
);

export default ContentLoader;
